'use strict';

var logEnabled = false;

var horisenLog = function () {
    if (logEnabled) console.log.apply(null, arguments);
    return horisenLog;
};
horisenLog.warn = function () {
    if (logEnabled) console.warn.apply(null, arguments);
    return horisenLog;
};
horisenLog.error = function () {
    if (logEnabled) console.error.apply(null, arguments);
    return horisenLog;
};
horisenLog.disable = function () {
    logEnabled = false;
    return horisenLog;
};
horisenLog.enable = function () {
    logEnabled = true;
    return horisenLog;
};

export default horisenLog;


//////////////////
// WEBPACK FOOTER
// ./src/services/log.js
// module id = 2
// module chunks = 0